import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { AppShell } from './components/layout/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { JobListPage } from './pages/jobs/JobListPage';
import { JobDetailPage } from './pages/jobs/JobDetailPage';
import { NewJobPage } from './pages/jobs/NewJobPage';
import { ApiKeysPage } from './pages/keys/ApiKeysPage';
import { CredentialsPage } from './pages/credentials/CredentialsPage';
import { IntegrationsPage } from './pages/integrations/IntegrationsPage';
import { OrgSettingsPage } from './pages/settings/OrgSettingsPage';
import { MembersPage } from './pages/settings/MembersPage';
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage';
import { Toaster } from './components/ui/toast';

export function App() {
  return (
    <>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />

      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/jobs" element={<JobListPage />} />
        <Route path="/jobs/new" element={<NewJobPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        <Route path="/keys" element={<ApiKeysPage />} />
        <Route path="/credentials" element={<CredentialsPage />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/settings" element={<OrgSettingsPage />} />
        <Route path="/settings/members" element={<MembersPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
    <Toaster />
    </>
  );
}
